<template>
    <div>
        <!-- Single vehicle timesheet history -->
        <timesheet-history :vehicle_id="selected_vehicle_id" v-if="selected_vehicle_id"></timesheet-history>

        <!-- All vehicle timesheet Data -->
        <vx-card title="Vehicle Timesheet" v-show="!selected_vehicle_id">
            <template slot="actions">
                <!-- <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            </template>
            <!-- Vehicle Counts -->
            <div class="vx-row m-0 pb-5 shadow justify-content-between">
                <div class="vx-col w-full mb-3">
                    <label class="">Year to date Totals for:</label>
                </div>
                <!-- Total Vehicle -->
                <div class="vx-col md:w-1/6 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_vehicles ? total_vehicles : 0}}</h6>
                            <span>Vehicles</span>
                        </div>
                        <feather-icon icon="TrendingUpIcon" class="rounded-full p-3 inline-flex rounded text-primary" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Trips -->
                <div class="vx-col md:w-1/6 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_trips ? total_trips : 0}}</h6>
                            <span>Trips</span>
                        </div>
                        <feather-icon icon="TrendingUpIcon" class="rounded-full p-3 inline-flex rounded text-primary" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Distance -->
                <div class="vx-col md:w-1/5 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_distances | validNumber }} Km</h6>
                            <span>Distance</span>
                        </div>
                        <feather-icon icon="UserIcon" class="rounded-full p-3 inline-flex rounded text-info" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Time -->
                <div class="vx-col md:w-1/5 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ convertToHoursMinutes(total_time) }}</h6>
                            <span>Time</span>
                        </div>
                        <feather-icon icon="BoxIcon" class="rounded-full p-3 inline-flex rounded text-danger" :style="{background: `rgba(var(--vs-danger),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Fuel Amount -->
                <div class="vx-col md:w-1/5 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">${{ total_fuel_amount ? total_fuel_amount : 0}}</h6>
                            <span>Fuel</span>
                        </div>
                        <feather-icon icon="DollarSignIcon" class="rounded-full p-3 inline-flex rounded text-success" :style="{background: `rgba(var(--vs-success),.10)`}"></feather-icon>
                    </div>
                </div>
            </div>
            <!-- Filters -->
            <form class="vs-row mt-6 mb-3 w-full inline-block timesheet-custom" autocomplete="off">
                <div class="vx-col md:w-1/4 float-left">
                    <v-select class="w-full" v-model="filter_office_id" :options="offices" label="office_name" index="id" placeholder="Select Office" />
                </div>
                <div class="vx-col float-right">
                    <vs-input class="w-full" icon-pack="feather" icon="icon-search" name="search" v-model="search" placeholder="Search Vehicle" autocomplete="off" />
                </div>
            </form>
            <div class="w-full word-custom">
                <vs-table :data="vehicle_list">
                    <template slot="thead">
                        <!-- <vs-th> </vs-th> -->
                        <vs-th> ID </vs-th>
                        <vs-th style="width: 20%;"> Vehicle </vs-th>
                        <vs-th> Registration# </vs-th>
                        <vs-th> Office </vs-th>
                        <vs-th> Trips </vs-th>
                        <vs-th> Distance </vs-th>
                        <vs-th> Fuel </vs-th>
                        <vs-th> Action </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                            <vs-td>{{ tr.vehical_id }}</vs-td>
                            <vs-td>{{ tr.name }} {{ tr.brand }}</vs-td>
                            <vs-td>{{ tr.number }}</vs-td>
                            <vs-td>{{ tr.office_id ? tr.office_id.office_name : '-' }}</vs-td>
                            <vs-td>{{ tr.tripsCount }}</vs-td>
                            <vs-td>{{ tr.distance | validNumber }} Km</vs-td>
                            <vs-td>{{ tr.fuelVolume ? tr.fuelVolume : 0 }} L</vs-td>
                            <vs-td>
                                <vs-button
                                v-if="tr.status !='R'"
                                type="filled"
                                icon-pack="feather"
                                icon="icon-eye"
                                size="small"
                                title="View Timesheet"
                                @click.prevent="selected_vehicle_id = tr.id"
                                ></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <div style="height:60px;" v-if="vehicle_list.length">
                    <div class="float-right mt-2">
                        <vs-pagination ref="pagination2" :total="total_page" v-model="current_page"></vs-pagination>
                    </div>
                </div>
            </div>

            
        </vx-card>
    </div>
</template>

<script>
import moment from "moment";
import TimesheetHistory from './timesheet-history.vue';
import vSelect from "vue-select";

export default {
  components: {
    TimesheetHistory,
    vSelect
  },
  data() {
    return {
        vehicle_list: [],
        total_vehicles: 0,
        total_trips: 0,
        total_distances: 0,
        total_time: 0,
        total_fuel_amount: 0,
        filter_office_id: null,
        offices: [],
        search: null,
        per_page: 10, 
        total_page: 1, 
        current_page: 1,
        show_vehicle_history: false,
        selected_vehicle_id: null,
        vehicle_details: {
            detail: {},
            total_trips: 0,
            total_distances: 0,
            total_time: 0,
            total_fuel_amount: 0,
            history: [],
        },
    };
  },
  watch: {
    current_page(nv) {
      if (nv) {
        this.getVechicleTimesheet();
      }
    },
    search(nv) {
      if (nv) {
        if (nv.length >= 3) {
            this.getVechicleTimesheet();
        }
      }else{
        this.getVechicleTimesheet();
      }
    },
    filter_office_id(nv){
        this.current_page = 1;
        this.getVechicleTimesheet();
    }
  },
  created() {
  },
  mounted() {
    this.getOffice();
    this.getVechicleTimesheet();
  },
  computed: {
  },
  methods: {
    convertToHoursMinutes(data){
        if (data) {
            let duration = moment.duration(data, 'milliseconds');
            let fromMinutes = Math.floor(duration.asMinutes());
            let fromSeconds = Math.floor(duration.asSeconds() - fromMinutes * 60);

            return Math.floor(duration.asSeconds()) >= 60 ? (fromMinutes<= 9 ? '0'+fromMinutes : fromMinutes) +':'+ (fromSeconds<= 9 ? '0'+fromSeconds : fromSeconds): '00:'+(fromSeconds<= 9 ? '0'+fromSeconds : fromSeconds);
        }
    },
    /** Get all Office */
    async getOffice() {
        this.$vs.loading({ color: "primary" });

        let url = "office/getAll";
        let response_data = await this.axios
                            .get(url)
                            .then(response => {
                                this.$vs.loading.close();
                                return response.data.data;
                            })
                            .catch(e => {
                                this.showError(e);
                            });
        if (response_data) {
            this.offices = response_data;
        }
    },
    /** Get vehicle timesheet list */
    async getVechicleTimesheet() {
        this.$vs.loading({ color: "primary" });
        let input = {
            office_id: this.filter_office_id,
            search: this.search,
            pageNo: this.current_page - 1,
            pageLimit: this.per_page
        };
        let url = "vehicleTimesheetGetAll";
        let response_data = await this.axios
                .get(url,{ params: input })
                .then(response => {
                    this.$vs.loading.close();
                    return response.data.data;
                })
                .catch(e => {
                    this.showError(e);
                    return null
                });
        if (response_data) {
            this.total_vehicles = response_data.totalVehicleHistory || 0;
            this.total_trips = response_data.totalTripHistory || 0;
            this.total_distances = response_data.totalDistance || 0;
            this.total_time = response_data.totalTime || 0;
            this.total_fuel_amount = response_data.totalFuel.toFixed(2) || 0;

            this.vehicle_list = response_data.findVehicals || [];
            this.total_page = response_data.pages;  
            
        }
    },
    /** show vehicle timesheet block */
    hideShowVechicleHistory(vehicle_id = null){
        if (vehicle_id) {
            this.show_vehicle_history = true;
            this.selected_vehicle_id = vehicle_id;
        }else{
            this.show_vehicle_history = false;
            this.selected_vehicle_id = null;
        }
    },
    
  }
};
</script>

		